<div class="assistant-loader-wrapper">

  <div class="assistant-ring-wrapper">
    <app-assistant-ring></app-assistant-ring>
  </div>

  <div class="loader-message">{{ (loaderMessage || 'COMPONENTS.ASSISTANT_LOADER.THINKING') | translate }}</div>

</div>
